import * as React from 'react';
import {
  Box,
  Button,
  Grid,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import ClearIcon from '@mui/icons-material/Clear';

import { BasicCodeCombo } from './BasicCodeCombo';
import { ComboRow } from './coremodels';

export type FWorkbenchFilterField = {
  name: string;
  label: string;
  items: ComboRow[];
  width?: number;
  disabled?: boolean;
  helperText?: string;
};

type Props = {
  title?: string;
  subtitle?: string;
  fields: FWorkbenchFilterField[];
  values: { [name: string]: any };
  onChange: (name: string, value: string) => void;
  onRefresh: () => void;
  onClear: () => void;
  loading?: boolean;
  refreshLabel?: string;
  clearLabel?: string;
};

export class FWorkbenchFilterBar extends React.Component<Props> {
  handleChange = (name: string) => (value: string) => {
    this.props.onChange(name, String(value || '').toUpperCase());
  };

  render() {
    const {
      title = 'Filters',
      subtitle,
      fields,
      values,
      onRefresh,
      onClear,
      loading,
      refreshLabel = 'Refresh',
      clearLabel = 'Clear',
    } = this.props;

    return (
      <Paper elevation={1} sx={{ p: 2, mb: 3 }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'stretch', md: 'center' }}
          spacing={2}
          sx={{ mb: 2 }}
        >
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
              {title}
            </Typography>
            {subtitle && (
              <Typography variant="caption" color="text.secondary">
                {subtitle}
              </Typography>
            )}
          </Box>

          <Stack direction="row" spacing={1}>
            <Button
              variant="outlined"
              startIcon={<ClearIcon />}
              onClick={onClear}
              disabled={loading}
            >
              {clearLabel}
            </Button>

            <Button
              variant="contained"
              startIcon={<RefreshIcon />}
              onClick={onRefresh}
              disabled={loading}
            >
              {refreshLabel}
            </Button>
          </Stack>
        </Stack>

        <Grid container spacing={2} alignItems="center">
          {fields.map((field) => (
            <Grid key={field.name} size={{ xs: 12, md: field.width || 3 }}>
              <BasicCodeCombo
                label={field.label}
                items={field.items || []}
                value={values[field.name] || ''}
                onChange={this.handleChange(field.name)}
                disabled={loading || field.disabled}
                helperText={field.helperText}
              />
            </Grid>
          ))}
        </Grid>
      </Paper>
    );
  }
}

export default FWorkbenchFilterBar;
